import { compose } from 'redux';
import { withProps } from 'recompose';
import ErrorScreen from '@dpdgroupuk/fmx-ui/components/ErrorScreen';
import { withPageControl } from '@dpdgroupuk/fmx-ui/components/Page';
import { IMAGES } from '@dpdgroupuk/fmx-ui/themes';
import {
  ERROR,
  TRY_AGAIN,
  PROBLEM_COMPLITING_REQUEST,
} from '../../constants/error';
import { ERROR_SCREEN, trackable } from '../../constants/analytics';

export default compose(
  withPageControl({
    title: ERROR,
    backgroundImage: IMAGES.TRACKING_BG,
    trackable: trackable(ERROR_SCREEN),
  }),
  withProps(() => ({
    title: PROBLEM_COMPLITING_REQUEST,
    buttonText: TRY_AGAIN,
    onClick: () => window.location.reload(),
  }))
)(ErrorScreen);
